import React, { Component } from 'react';
import { arrayOf, object } from 'prop-types';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PAGES, THEMES } from 'common/const';
//import { loadCRMScripts } from 'common/crmScripts';
//import { initCookieConsent } from 'common/cookieConsent';
import { ErrorBoundary, AppHeader, AppContext, Page } from './components';
import { Order, Orders, QnA } from './pages';
import { AuthPage, SignOutPage, AuthenticationCheck } from 'auth';

import './app.css';

const Routes = ({ pages }) => {
    return (
        <Switch>
            {pages.map(({ path, component, exact, authRequired }) => (
                <Route key={path} exact={exact} path={path}>
                    {data => (
                        <AppContext.Consumer>
                            {ctx => {
                                if (authRequired) {
                                    return (
                                        <AuthenticationCheck>
                                            <Page
                                                component={component}
                                                data={data}
                                                ctx={ctx}
                                            />
                                        </AuthenticationCheck>
                                    );
                                } else {
                                    return (
                                        <Page
                                            component={component}
                                            data={data}
                                            ctx={ctx}
                                        />
                                    );
                                }
                            }}
                        </AppContext.Consumer>
                    )}
                </Route>
            ))}
            <Route path={`/:token/reset-pass/:userUid/`} component={AuthPage} />
            <Route path={`/logout`} component={SignOutPage} />
        </Switch>
    );
};

class App extends Component {
    constructor(props) {
        super(props);

        this.handleChangePage = page => {
            this.setState({ page });
        };

        this.handleChangeTheme = theme => {
            this.setState({ theme });
        };

        this.state = {
            page: PAGES.LANDING,
            theme: THEMES.TEAL,
            changePage: this.handleChangePage,
            changeTheme: this.handleChangeTheme
        };
    }
    static propTypes = {
        pages: arrayOf(object).isRequired
    };

    static defaultProps = {
        pages: [
            {
                title: '',
                path: '/',
                component: Order,
                exact: true
            },
            {
                title: '',
                path: PAGES.ORDERS,
                component: Orders,
                exact: true,
                authRequired: true
            },
            {
                title: '',
                path: `${PAGES.ORDERS}/:id`,
                component: QnA,
                exact: true,
                authRequired: true
            }
        ]
    };

    componentDidMount() {
        window.onload = function() {
            //loadCRMScripts();
            //initCookieConsent();
        };
    }

    render() {
        const { pages, store } = this.props;

        return (
            <Provider store={store}>
                <BrowserRouter>
                    <AppContext.Provider value={this.state}>
                        <AppHeader current={this.state.page} pages={pages} />
                        <ErrorBoundary>
                            <div className="page-container">
                                <Routes pages={pages} />
                            </div>
                        </ErrorBoundary>
                    </AppContext.Provider>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default App;
